import { render } from "./TheBikes.vue?vue&type=template&id=25e18e7e"
import script from "./TheBikes.vue?vue&type=script&lang=js"
export * from "./TheBikes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__